// export const BACKEND_SERVER = 'http://localhost:8000/backend/api'
export const BACKEND_SERVER = import.meta.env.VITE_BACKEND_SERVER as string; // I found that I still needed to type the imported var to get around https://typescript-eslint.io/rules/no-unsafe-assignment/
export const BACKEND_SERVER_PROD = import.meta.env
  .VITE_BACKEND_SERVER_PROD as string;
export const PRICE_NO_SALE = import.meta.env.VITE_PRICE_NO_SALE;
export const PRICE_SALE = import.meta.env.VITE_PRICE_SALE;
export const BACKEND_SERVER_NINJA = import.meta.env
  .VITE_BACKEND_SERVER_NINJA as string;
